var portalEditRequestPendingTable;
var portalEditRequestPendingTableOnChangeDisabled = false;

var portalEditRequestAcceptedTable;
var portalEditRequestAcceptedTableOnChangeDisabled = false;

function CreatePortalEditRequestTables() {

    var residentTerm = "Resident";
    var tableHeight = window.innerHeight - 128 - 256;

    if (tableHeight < 256) {
        tableHeight = 256;
    }
    try {

        portalEditRequestPendingTable = jexcel(document.getElementById('portaleditrequestpendinggrid'), {
            allowManualInsertColumn: false,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            allowInsertRow: false,
            allowManualInsertRow: false,
            allowDeleteRow: false,
            selectionCopy: false,
            columnDrag: false,
            data: null,
            pagination: 100,
            tableWidth: '100%',
            tableHeight: tableHeight + 'px',
            minDimensions: [2, 20],
            wordWrap: true,
            search: true,
            tableOverflow: true,
            columns: [
                {
                    title: 'Time',
                    type: 'text',
                    width: '200px',
                    readOnly: true
                },
                {
                    title: residentTerm + ' Unit',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: residentTerm + ' Name',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: 'Field',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: 'Field',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: 'Data',
                    type: 'text',
                    width: '150px'
                },
                {
                    title: 'Accept',
                    type: 'html',
                    width: '200px',
                    readOnly: true
                },
                {
                    title: 'Reject',
                    type: 'html',
                    width: '200px',
                    readOnly: true
                },
                {
                    title: 'Comment',
                    type: 'html',
                    readOnly: true,
                    width: '200px'
                },
            ],
            rowResize: true,
            onload: function (instance) {
                //Seperator colors

                //$($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                //    $(obj).css("background-color", "#ccc");
                //});

                $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                    if (i == 0) {
                        $(obj).css("font-weight", "bold");
                    }
                });

                $($(instance).find('td[data-x="6"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#f0f0f0");
                });

                $($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#f0f0f0");
                });

                $($(instance).find('td[data-x="8"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#f0f0f0");
                });



                $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                    if (i == 0) {
                        $(obj).css("font-weight", "bold");
                    }
                });

                $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                    $(obj).prepend($("#people-autoadmit-header-checkin-title"));
                });

                $(".jexcel_search").css({ "border": "1px solid #ccc" });


                try {

                    $($(instance).find('td[data-x="6"]')).each(function (i, obj) {
                        if (i == 0) {
                            $(obj).html('<i class="fas fa-check text-success" style="font-size:100%;padding-right:5px;"></i><span>' + 'Accept' + '</span>');
                        }
                    });


                    $($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                        if (i == 0) {
                            $(obj).html('<i class="fas fa-times text-danger" style="font-size:100%;padding-right:5px;"></i><span>' + 'Reject' + '</span>');
                        }
                    });


                    $($(instance).find('td[data-x="8"]')).each(function (i, obj) {
                        if (i == 0) {
                            $(obj).html('<i class="fas fa-comment text-info" style="font-size:100%;padding-right:5px;"></i><span>' + 'Comment' + '</span>');
                        }
                    });

                   

                } catch (e) {
                    console.log(e);
                }


            },
            onchange: function (obj, cel, val) {
                // Used to avoid onchange event to propagate
                if (portalEditRequestPendingTableOnChangeDisabled) {
                    return;
                }

                var checkinId = 0;
                var newValue = "";
                var columnToUpdate = "";

                //Grid coordinates of data just updated
                var x = parseInt($(cel).attr("data-x"));
                var y = parseInt($(cel).attr("data-y"));


            },
            onselection: function (instance, x1, y1, x2, y2, origin) {




             

                var t = portalEditRequestPendingTable.getSelectedColumns(true);
                var buttonColumnIndex = 8;
                var buttonColumnIndex2 = 7;
                var buttonColumnIndex3 = 6;

                //Stop the selection if user selects checkin timestamp or checkout button cols
                if (t != null && ((t.indexOf(buttonColumnIndex) >= 0 || t.indexOf(buttonColumnIndex2) >= 0 || t.indexOf(buttonColumnIndex3) >= 0) && t.indexOf(1) == -1)) {


                    portalEditRequestPendingTable.resetSelection(false);


                }

            },
            onbeforechange: function (instance, cell, x, y, value) {

            },
        });


        portalEditRequestAcceptedTable = jexcel(document.getElementById('portaleditrequestacceptedgrid'), {
            allowManualInsertColumn: false,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowRenameColumn: false,
            allowInsertRow: false,
            allowManualInsertRow: false,
            allowDeleteRow: false,
            selectionCopy: false,
            columnDrag: false,
            data: null,
            pagination: 100,
            tableWidth: '100%',
            tableHeight: tableHeight + 'px',
            minDimensions: [2, 20],
            wordWrap: true,
            search: true,
            tableOverflow: true,
            columns: [
                {
                    title: 'Time',
                    type: 'text',
                    width: '200px',
                    readOnly: true
                },
                {
                    title: residentTerm + ' Unit',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: residentTerm + ' Name',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: 'Field',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: 'Field',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: 'Data',
                    type: 'text',
                    width: '150px',
                    readOnly: true
                },
                {
                    title: 'Accept',
                    type: 'text',
                    width: '200px',
                    readOnly: true
                },
                {
                    title: 'Reject',
                    type: 'text',
                    width: '200px',
                    readOnly: true
                },
                {
                    title: 'Comment',
                    type: 'text',
                    readOnly: true,
                    width: '200px'
                },
            ],
            rowResize: true,
            onload: function (instance) {
                //Seperator colors

                //$($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                //    $(obj).css("background-color", "#ccc");
                //});

                $($(instance).find('td[data-x="1"]')).each(function (i, obj) {
                    if (i == 0) {
                        $(obj).css("font-weight", "bold");
                    }
                });

                $($(instance).find('td[data-x="6"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#f0f0f0");
                });

                $($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#f0f0f0");
                });

                $($(instance).find('td[data-x="8"]')).each(function (i, obj) {
                    $(obj).css("background-color", "#f0f0f0");
                });



                $($(instance).find('td[data-x="2"]')).each(function (i, obj) {
                    if (i == 0) {
                        $(obj).css("font-weight", "bold");
                    }
                });

                $($(instance).find('.jexcel_filter')).each(function (i, obj) {
                    $(obj).prepend($("#people-autoadmit-header-checkin-title"));
                });

                $(".jexcel_search").css({ "border": "1px solid #ccc" });


                try {

                    $($(instance).find('td[data-x="6"]')).each(function (i, obj) {
                        if (i == 0) {
                            $(obj).html('<i class="fas fa-check text-success" style="font-size:100%;padding-right:5px;"></i><span>' + 'Accepted' + '</span>');
                        }
                    });


                    $($(instance).find('td[data-x="7"]')).each(function (i, obj) {
                        if (i == 0) {
                            $(obj).html('<i class="fas fa-times text-danger" style="font-size:100%;padding-right:5px;"></i><span>' + 'Rejected' + '</span>');
                        }
                    });


                    $($(instance).find('td[data-x="8"]')).each(function (i, obj) {
                        if (i == 0) {
                            $(obj).html('<i class="fas fa-comment text-info" style="font-size:100%;padding-right:5px;"></i><span>' + 'Comment' + '</span>');
                        }
                    });


                } catch (e) {
                    console.log(e);
                }


            },
            onchange: function (obj, cel, val) {
                // Used to avoid onchange event to propagate
                if (portalEditRequestAcceptedTableOnChangeDisabled) {
                    return;
                }

                var checkinId = 0;
                var newValue = "";
                var columnToUpdate = "";

                //Grid coordinates of data just updated
                var x = parseInt($(cel).attr("data-x"));
                var y = parseInt($(cel).attr("data-y"));


            },
            onselection: function (instance, x1, y1, x2, y2, origin) {




                portalEditRequestAcceptedTable.resetSelection(false);

                var t = portalEditRequestAcceptedTable.getSelectedColumns(true);
                var buttonColumnIndex = 8;
                var buttonColumnIndex2 = 7;
                var buttonColumnIndex3 = 6;

                //Stop the selection if user selects checkin timestamp or checkout button cols
                if (t != null && ((t.indexOf(buttonColumnIndex) >= 0 || t.indexOf(buttonColumnIndex2) >= 0 || t.indexOf(buttonColumnIndex3) >= 0) && t.indexOf(1) == -1)) {



                }

            },
            onbeforechange: function (instance, cell, x, y, value) {

            },
        });

    } catch (e) {
        console.log(e);
    }
}

//function proxyPopulatePendingEditRequestTable(editRequestsPending) {

//    if (portalEditRequestPendingTable != null) {
//        console.log("json parse time 1");
//        console.log(new Date());
//        const data = BINDING.conv_string(editRequestsPending);
//        portalEditRequestPendingTable.setData(JSON.parse(data), false);
//        console.log("json parse time 2");
//        console.log(new Date());
//    } else {
//    }
//}

function proxyPopulatePendingEditRequestTable(data) {
    try {
        if (!portalEditRequestPendingTable) return;

        // If C# passed a string, parse it; if it passed an object/array, use as-is.
        const rows = (typeof data === 'string') ? JSON.parse(data) : data;

        portalEditRequestPendingTable.setData(rows ?? [], false);
    } catch (err) {
        console.error("Failed to populate table", err, data);
    }
}

//function proxyPopulateAcceptedEditRequestTable(editRequestsAccepted) {

//    if (portalEditRequestAcceptedTable != null) {
//        console.log("json parse time 1");
//        console.log(new Date());
//        const data = BINDING.conv_string(editRequestsAccepted);
//        portalEditRequestAcceptedTable.setData(JSON.parse(data), false);
//        console.log("json parse time 2");
//        console.log(new Date());
//    } else {
//    }
//}

function proxyPopulateAcceptedEditRequestTable(data) {
    try {
        if (!portalEditRequestAcceptedTable) return;

        // If C# passed JSON text, parse it; if it passed an object/array, use as-is.
        const rows = (typeof data === 'string') ? JSON.parse(data) : data;

        portalEditRequestAcceptedTable.setData(rows ?? [], false);
    } catch (err) {
        console.error("Failed to populate accepted table", err, data);
    }
}



function HandlePortalRequest(act, portalRequestId) {
    console.log("act: " + act + " - portalRequestId: " + portalRequestId);
    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnHandlePortalRequestFromGrid', act, portalRequestId);
}



function startHandleAll(argument) {



    swal({
        title: "Confirm",
        text: "Are you sure?",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnHandleAllPortalRequestFromGrid', 0, argument);
            swal("OK.", "yes", "success");

        });
}